/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { Tooltip } from "./Tooltip";

/**
 * How sure an agent was, as a compact purple arc with a real tooltip. The default copy speaks for
 * the scheduling agent; surfaces for other domains pass their own `hint`.
 */
export function ConfidenceRing({
  value,
  hint = (pct) =>
    `The agent was ${pct}% sure about booking on its own. Below the threshold, it asks a coordinator instead.`,
}: {
  value: number;
  hint?: (pct: number) => string;
}) {
  const pct = Math.round(value * 100);
  const radius = 16;
  const circumference = 2 * Math.PI * radius;
  return (
    <Tooltip
      className="max-w-[280px] whitespace-normal"
      content={hint(pct)}
      side="top"
    >
      <div className="relative grid size-11 shrink-0 place-items-center text-text-tertiary">
        <svg viewBox="0 0 36 36" className="size-11 -rotate-90">
          <circle
            cx="18"
            cy="18"
            r={radius}
            fill="none"
            stroke="currentColor"
            strokeOpacity="0.18"
            strokeWidth="2.5"
          />
          <circle
            cx="18"
            cy="18"
            r={radius}
            fill="none"
            className="text-accent"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={circumference * (1 - value)}
          />
        </svg>
        <span className="absolute text-[11px] font-semibold text-text-secondary">{pct}</span>
      </div>
    </Tooltip>
  );
}
